module.exports = __webpack_public_path__ + "static/media/233-transnistria.b0bace6a.svg";